@import '~swiper/swiper.min.css';
@import '~swiper/modules/navigation.min.css';

:host {
  display: block;
}

lilu-swiper {
  position: relative;
}

.swiper-link {
  margin-left: 5px;
  @include breakpointMin('md') {
    position: relative;
    top: 35px;
    left: 10px;
    z-index: 2;
    width: fit-content;
    max-width: calc(100% - 170px);
    white-space: nowrap;
    overflow: hidden;

    /* If gradient is required

    min-width: calc(100% - 170px);
    ::after {
      content: '';
      position: absolute;
      top:0;
      left:0;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 90%, rgba(255,255,255,1) 100%);
      pointer-events: none;
    }
      */
  }
}

.mySwiper {
  --swiper-background-color: inherit;
  overflow: hidden;

  .swiper {
    overflow: unset;
  }

  &.swiper-product {
    font-family: var(--primary-font);
    position: relative;
    width: 100%;
    max-width: 1400px;
    height: auto;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 75px;

    @include breakpointMin('md') {
      padding-top: 40px;
      padding-bottom: 50px;
    }

    @include breakpointMin('lg') {
      padding-bottom: 110px;
    }
  }

  .swiper-slide {
    padding-left: 5px;
    padding-right: 5px;
    background: var(--color-white);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: visible !important;
    height: auto;

    @include breakpointMin('md') {
      padding-left: 10px;
      padding-right: 10px;
    }

    img {
      display: block;
    }
  }

  .swiper-navigation {
    position: absolute;
    bottom: -80px;
    left: 50%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    transform: translate(-50%, 0);
    z-index: 2;

    @include breakpointMin('md') {
      position: absolute;
      top: -60px;
      right: 0;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 150px;
      transform: inherit;
      left: initial;
      bottom: initial;
    }

    .swiper-pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      bottom: 15px;
    }

    .swiper-button-next {
      &:after {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        background: var(--color-bleached-silk);
        border-radius: 50px;
        color: var(--color-nero);
      }
    }

    .swiper-button-prev {
      &:after {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        background: var(--color-bleached-silk);
        border-radius: 50px;
        color: var(--color-nero);
      }
    }
  }

  &-link {
    position: absolute;
    left: 10px;
    top: 20px;
    width: 100%;
    text-align: center;

    @include breakpointMin('md') {
      width: auto;
      text-align: left;
    }
  }

  lilu-hr {
    padding-left: 5px;
    padding-right: 5px;
    max-width: 1400px;
    margin: 0 auto;

    @include breakpointMin('md') {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}

lilu-product-tile.skeleton-tile {
  width: 100%;
  margin-top: -10px;
}

/* START Specific CSS for the carousel with a fixed tile */

lilu-swiper[type='fix'] {
  .swiper-link {
    @include breakpointMin('md') {
      top: 15px;
    }
  }
}

.swiper-type-fix {
  position: relative;

  lilu-fix-product-tile[type='desktop'] {
    display: none;
  }

  @include breakpointMin('md') {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-areas: 'fix swiper swiper swiper';

    lilu-fix-product-tile[type='desktop'] {
      display: block;
      grid-area: fix;
      align-self: end;
      margin-left: 10px;
      height: calc(100% - 110px);
      margin-bottom: 50px;

      @include breakpointMin('lg') {
        height: calc(100% - 170px);
        margin-bottom: 110px;
      }
    }
  }

  .mySwiper {
    grid-area: swiper;

    &.swiper-product {
      position: static;

      @include breakpointMin('md') {
        padding-top: 60px;
      }

      lilu-fix-product-tile[type='mobile'] {
        height: 100%;
      }

      @include breakpointMin('md') {
        .swiper-slide:has(lilu-fix-product-tile) {
          display: none;
        }
      }
    }
  }

  lilu-hr {
    width: 100%;

    @include breakpointMin('md') {
      position: absolute;
      top: 44px;
      left: 0;
    }
  }
}

/* END Specific CSS for the carousel with a fixed tile */
